import { useFormContext, SubmitFormButton, RadioField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FormFooter } from '../styles';
const formFieldsContainerCss = "f1ci7pf2";
const FormFieldsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formFieldsContainerCss, props.className)} />;
});
export const FormContent = () => {
  const {
    values,
    handleReset
  } = useFormContext();
  const {
    workflowsEnabledFor: permission
  } = values;
  const showWarning = permission === 'admins_only';
  return <>
      <FormFieldsContainer>
        <RadioField label={I18n.t('publisher.organization_settings.workflows.enabled_for.all_members')} name="workflowsEnabledFor" value="all_organization_members" />
        <RadioField label={I18n.t('publisher.organization_settings.workflows.enabled_for.only_admins')} name="workflowsEnabledFor" value="admins_only" />
      </FormFieldsContainer>
      {showWarning && <ContextualBanner variant="warning" spacingBottom={16}>
          {I18n.t('publisher.organization_settings.workflows.enabled_for.warning')}
        </ContextualBanner>}
      <FormFooter>
        <Button decoration="secondary-outline" onClick={handleReset}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <SubmitFormButton>
          {I18n.t('publisher.action.save')}
        </SubmitFormButton>
      </FormFooter>
    </>;
};

require("./form_content.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_content.js");